import { render, staticRenderFns } from "./Nueva-categoria-caja.vue?vue&type=template&id=30c00ca7"
import script from "./Nueva-categoria-caja.vue?vue&type=script&lang=js"
export * from "./Nueva-categoria-caja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports